<template lang="html">
  <div class="userInfo" :style="{backgroundImage: 'url('+ detailsIist.background +')'}">
    <!-- 标题 -->
    <div v-title :data-title="title" :key="title"></div>

    <!-- 试题测试须知 -->
    <div class="notice_mod">
      <div class="notice_head">测试须知</div>
      <div class="notice_con" v-html="detailsIist.desc"></div>
      <div class="notice_particulars" @click="showParticulars">
        查看详情
      </div>
    </div>

    <div class="notice_alert" v-show="showDetails">
      <Notice v-bind:details = 'detailsIist.desc' />
    </div>

    <div class="img_mod">
      <div class="particulars" @click="showParticulars">
        <img src="../../assets/image/exam/details.png" alt="">
      </div>
    </div>

    <div class="" v-if="detailsIist.auth_type == 1">
      <div class="form_name">
        <div class="form_txt elecOm">电巢用户名</div>
        <div class="form_input">
          <input type="text" name="" value="" placeholder="留下名字方便领取奖品"  @blur="fixScroll" v-model="name">
        </div>
      </div>
      <div class="form_name">
        <div class="form_txt_InvitationCode">输入邀请码</div>
        <div class="form_input">
          <input type="text" name="" value="" placeholder="请输入你的邀请码"  @blur="fixScroll" v-model="authCode">
        </div>
      </div>
    </div>
    <div class="" v-if="detailsIist.auth_type == 2">
      <div class="form_name">
        <div class="form_txt elecOm">电巢用户名</div>
        <div class="form_input">
          <input type="text" name="" value="" placeholder="留下名字方便领取奖品"  @blur="fixScroll" v-model="name">
        </div>
      </div>
      <div class="form_name">
        <div class="form_txt">电话</div>
        <div class="form_input">
          <input type="text" name="" value="" placeholder="留下电话方便领取奖品" @blur="fixScroll" v-model="phone">
        </div>
      </div>
      <div class="form_name">
        <div class="form_input_authCode">
          <input type="text" name="" value="" placeholder="填写验证码" @blur="fixScroll" v-model="authCode">
        </div>
        <div class="form_txt_authCode" @click="getAuthCode">
          {{content}}
        </div>
      </div>
    </div>

    <div class="start_testing">
      <div class="start_testing_btn" @click="startTesting">
        <p>开启测试</p>
        <img src="../../assets/image/exam/start_testing.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import utils from '@/utils/utils.js';
import Notice from './else/Notice.vue';

var i=1;

export default {
  data() {
    return {
      title: '',
      detailsIist: '',
      showDetails: false,
      name: '',
      phone: '',
      authCode: '',
      content: '获取',
      totalTime: 120,
      startMusic: true,
      endMusic: false,
    }
  },
  components:{
    Notice,
  },
  created(){
    // 查看全部测试须知
    this.details();
  },
  mounted(){
  },
  methods:{
    fixScroll() {
      document.body.scrollTop = 0;
    },
    // 获取测试须知内容  试卷title
    details(){
      this.$http({
        url: '/paper/getPaperAuthType',
        method: 'get',
        params: {
          task_id: this.$route.query.task_id,
        },
      }).then((res) => {
				if(res.code >= 0){
					this.$nextTick(function(){
						this.title = res.data.title;
					},0);
					this.detailsIist = res.data;
				}
      })
    },

    // 点击查看详情按钮
    showParticulars(){
      this.$nextTick(function(){
        this.details();
      },0);
      this.showDetails = true;
    },
    rotate(){
      $(".music").css("transform","rotate("+i+"deg");
      if(i==360) i=1
      else i=i+1;
    },
    getMusic(){
      window.setInterval(this.rotate, 50);
      // 放音乐
    },
    playMusic(){
      this.$refs.MusicPlay.play();
      this.musicTF = false;
      this.startMusic = false;
      this.endMusic = true;
    },

    // 获取验证码
    getAuthCode(){
      if(this.phone == ''){
        utils.showMessage('手机号输入错误')
      }else{
        this.$http({
          url: '/Registered/getPhoneSmsCode',
          method: 'get',
          params: utils.cso({
            phone: this.phone,
            phone_head: 86,
            type: 9,
            client: 'H5'
          })
        }).then((res) => {
          if(res.code >= 0){
            this.content = this.totalTime + 's';
            let clock = window.setInterval(() => {
              this.totalTime--;
              this.content = this.totalTime + 's';
              if (this.totalTime < 0) {
                window.clearInterval(clock);
                this.content = '获取';
                this.totalTime = 120;
              }
            },1000)
          }else{
            utils.showMessage(res.msg);
          }
        })
      }
    },

    // 点击开始测试按钮
    startTesting(){
      if(this.name != ''){
        if(this.phone != ''){
          if(this.authCode != ''){
            this.$http({
              url: "/paper/info",
              method: 'get',
              params: {
                task_id: this.$route.query.task_id,
                name: this.name,
                user_unique_id: this.phone,
                auth_code: this.authCode,
              },
            }).then((res) => {
              if(res.code >= 0){
								var thisId = res.data.test_id;
                if(thisId != 0){
                  this.$http({
                    url: "/paper/doTest",
                    method: 'POST',
                    params: {
                      task_id: this.$route.query.task_id,
                      test_id: thisId,
                      action: 'start',
                      user_unique_id: this.phone,
                      auth_code: this.authCode,
                      name: this.name,
                    },
                  }).then(() => {
                    this.$router.replace({
                      path: '/subject',
                      query:{
                        task_id: this.$route.query.task_id,
                        test_id: thisId,
                        phone: this.phone,
                        auth_code: this.authCode,
                        name: this.name,
                      }
                    });
                  })
                }else{
                  this.$router.replace({
                    path: '/examSucceed',
                    query:{
                      task_id: this.$route.query.task_id,
                      test_id: thisId,
                      phone: this.phone,
                      auth_code: this.authCode,
                      name: this.name,
                    }
                  })
                  utils.showMessage('本次考试次数已用完');
                }
              }else{
                utils.showMessage(res.msg);
              }
            })
          }else{
            utils.showMessage('验证码有误');
          }
        }else{
          utils.showMessage('请留下电话方便领取奖品');
        }
      }else{
        utils.showMessage('请留下名字方便领取奖品');
      }
    },

    // 关闭测试须知详情弹框
    noticeShow(boole){
      this.showDetails = boole;
    },
  }
}
</script>

<style lang="css" scoped>
.userInfo{
  width: 100%;
  height: 100%;
  /* background: url("../../assets/image/exam/back.jpg"); */
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: auto;
  box-sizing: border-box;
  padding: 0 1.5rem;
  padding-top: 3rem;
}
.notice_mod{
  background: url("../../assets/image/exam/noticeBackground.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 36rem;
  position: relative;
  box-sizing: border-box;
  padding: 0 1rem 0 2.5rem;
}
.notice_head{
  box-sizing: border-box;
  font-size: 1.8rem;
  color: #060606;
  width: 10.2rem;
  height: 3.2rem;
  position: absolute;
  left: 50%;
  margin-left: -5.1rem;
  background-color: #FEE84F;
  text-align: center;
  border: 0.2rem solid #000000;
  border-radius: 1.6rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: -0.5rem;
}
.notice_con{
  height: 29rem;
  box-sizing: border-box;
  padding-top: 4rem;
  /* padding: 4rem 0 7rem 0; */
  overflow: hidden;
  font-size: 1.6rem;
}
.notice_particulars{
  box-sizing: border-box;
  font-size: 1.8rem;
  color: #440FCB;
  width: 11.4rem;
  height: 3.2rem;
  position: absolute;
  left: 50%;
  bottom: 2.5rem;
  margin-left: -5.1rem;
  text-align: center;
  border: 0.1rem solid #440FCB;
  border-radius: 1.6rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 1.4rem;
}
.notice_alert{
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.65);
  z-index: 5;
  padding: 2rem 1.5rem;
  background-size: 100% 100%;
}

.img_mod{
  position: fixed;
  top: .9rem;
  right: 0;
  display: flex;
  margin-right: 1.6rem;
}
.particulars{
  width: 4rem;
  height: 4rem;
  margin-right: 1rem;
}
.particulars img{
  width: 4rem;
  height: 4rem;
}
.music{
  width: 4rem;
  height: 4rem;
}
.music img{
  width: 4rem;
  height: 4rem;
}
.closeMusic{
  width: 4rem;
  height: 4rem;
}
.closeMusic img{
  width: 4rem;
  height: 4rem;
}




.form_name{
  display: flex;
  padding: 0 1rem;
  box-sizing: border-box;
  margin-top: 1.2rem;
  justify-content: center;
}
.form_txt{
  width: 7rem;
  height: 4rem;
  line-height: 4rem;
  text-align: center;
  background-color: #4EE4BC;
  border: .2rem solid #000;
  border-radius: 2rem 0 0 2rem;
  font-size: 1.6rem;
  color: #120A46;
}
.elecOm{
  width: 12rem;
}
.form_input{
  width: 25rem;
  height: 4rem;
  line-height: 4rem;
  background-color: #FFF;
  border: .2rem solid #000;
  border-left: none;
  border-radius: 0 2rem 2rem 0;
  overflow: hidden;
}
.form_input input{
  width: 100%;
  height: 4rem;
  line-height: 4rem;
  border: none;
  outline: none;
  padding-left: 1rem;
  padding-right: 1rem;
  box-sizing: border-box;
  overflow: hidden;
  font-size: 1.6rem;
}
.form_txt_InvitationCode{
  width: 11.8rem;
  height: 4rem;
  line-height: 4rem;
  text-align: center;
  background-color: #4EE4BC;
  border: .2rem solid #000;
  border-radius: 2rem 0 0 2rem;
  font-size: 1.6rem;
  color: #120A46;
}
.form_txt_authCode{
  width: 9rem;
  height: 4rem;
  line-height: 4rem;
  text-align: center;
  background-color: #4EE4BC;
  border: .2rem solid #000;
  border-radius: 0 2rem 2rem 0;
  font-size: 1.6rem;
  color: #120A46;
}
.form_input_authCode{
  width: 22.8rem;
  height: 4rem;
  line-height: 4rem;
  background-color: #FFF;
  border: .2rem solid #000;
  border-right: none;
  border-radius: 2rem 0 0 2rem;
  overflow: hidden;
}
.form_input_authCode input{
  width: 100%;
  height: 4rem;
  line-height: 4rem;
  border: none;
  outline: none;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 1.6rem;
  box-sizing: border-box;
  overflow: hidden;
}

.start_testing{
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  padding-bottom: 3rem;
}
.start_testing_btn{
  box-sizing: border-box;
  width: 21.25rem;
  height: 5rem;
  border-radius: 5rem;
  background: linear-gradient(#FFFFFF , #04DDAB);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.8rem;
  font-weight: 600;
  color: #120A46;
}
.start_testing_btn p{
  margin-top: -.2rem;
}
.start_testing_btn img{
  width: 3.2rem;
  height: 3.2rem;
  margin-top: .2rem;
  margin-left: .85rem;
}
</style>
